import React from 'react';
import { Link } from 'react-router-dom';
import '../pages/styles.css';

const socialLinks = [
  { href: 'https://facebook.com/raffcodes', icon: 'facebook-f', label: 'Facebook' },
  { href: 'https://twitter.com/raffcodes', icon: 'twitter', label: 'Twitter' },
  { href: 'https://linkedin.com/company/raffcodes', icon: 'linkedin-in', label: 'LinkedIn' },
  { href: 'https://instagram.com/raffcodes', icon: 'instagram', label: 'Instagram' },
  { href: 'https://github.com/raffcodes', icon: 'github', label: 'GitHub' },
  { href: 'https://t.me/raffcodes', icon: 'telegram-plane', label: 'Telegram' },
];

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer" role="contentinfo">
      <div className="footer-container">
        {/* Brand Section */}
        <div className="footer-brand footer-section">
          <div className="footer-logo">
            <img 
              src="/images/raffcodes-logo.png" 
              alt="Raffcodes - IT Solutions Logo" 
              loading="lazy"
              width="200"
              height="80"
            />
          </div>
          <p className="footer-tagline">
            <strong>From Idea to Interface.</strong> Reliable IT solutions from system setup to full-stack development.
          </p>
          <div className="footer-trust-badge">
            <span className="trust-badge">
              <i className="fas fa-shield-alt"></i> Trusted in Kenya
            </span>
          </div>
        </div>

        {/* Quick Links */}
        <div className="footer-section">
          <h3 className="footer-heading">Quick Links</h3>
          <ul className="footer-links">
            <li><Link to="/"><i className="fas fa-chevron-right"></i> Home</Link></li>
            <li><Link to="/services"><i className="fas fa-chevron-right"></i> Services</Link></li>
            <li><Link to="/about"><i className="fas fa-chevron-right"></i> About Us</Link></li>
            <li><Link to="/portfolio"><i className="fas fa-chevron-right"></i> Portfolio</Link></li>
            <li><Link to="/contact"><i className="fas fa-chevron-right"></i> Contact</Link></li>
            <li><Link to="/reviews"><i className="fas fa-chevron-right"></i> Reviews</Link></li>
          </ul>
        </div>

        {/* Our Services */}
        <div className="footer-section">
          <h3 className="footer-heading">Our Services</h3>
          <ul className="footer-links">
            <li><Link to="/services/development"><i className="fas fa-chevron-right"></i> Full-Stack Development</Link></li>
            <li><Link to="/services/setup"><i className="fas fa-chevron-right"></i> System Setup & Maintenance</Link></li>
            <li><Link to="/services/troubleshooting"><i className="fas fa-chevron-right"></i> Troubleshooting & Repair</Link></li>
            <li><Link to="/services/networking"><i className="fas fa-chevron-right"></i> Networking Solutions</Link></li>
            <li><Link to="/services/consulting"><i className="fas fa-chevron-right"></i> IT Consulting</Link></li>
          </ul>
        </div>

        {/* Contact Info */}
        <div className="footer-section">
          <h3 className="footer-heading">Contact Info</h3>
          <ul className="footer-contact">
            <li>
              <i className="fas fa-map-marker-alt"></i> 
              <span>Munyu Road, Nairobi, Kenya</span>
            </li>
            <li>
              <i className="fas fa-phone"></i> 
              <a href="tel:+254115016167">+254 115-01 6167</a>
            </li>
            <li>
              <i className="fas fa-envelope"></i> 
              <a href="mailto:support@raffcodes.tech">
                support@raffcodes.tech
              </a>
            </li>
            <li>
              <i className="fab fa-whatsapp"></i> 
              <a 
                href="https://wa.me/254780362819" 
                target="_blank" 
                rel="noopener noreferrer"
                className="whatsapp-link"
              >
                Chat with us on WhatsApp
              </a>
            </li>
            <li>
              <i className="fas fa-clock"></i> 
              <span>Mon-Fri: 8:00 AM - 6:00 PM</span>
            </li>
          </ul>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="footer-bottom-content">
          <div className="social-links">
            {socialLinks.map(({ href, icon, label }) => (
              <a 
                key={icon} 
                href={href} 
                target="_blank" 
                rel="noopener noreferrer" 
                aria-label={label} 
                title={label}
                className={`social-icon ${icon}`}
              >
                <i className={`fab fa-${icon}`}></i>
              </a>
            ))}
          </div>
          <p className="copyright">
            © {currentYear} Raffcodes. All rights reserved. 
            <span className="copyright-separator">|</span>
            <span className="copyright-tagline">From Idea to Interface</span>
          </p>
          <div className="footer-legal">
            <a href="/privacy-policy">Privacy Policy</a>
            <span className="legal-separator">|</span>
            <a href="/terms-of-service">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;